import { autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
export class ExportCustomReportDialog {

    public onConfirm: () => void;
    
    constructor(private dialogClientService: DialogClientService) { }

    activate(model: { onConfirm: () => void, id: number }) {
        this.onConfirm = model.onConfirm;
    }

    close() {
        this.dialogClientService.hide();
    }

    ok() {
        if (this.onConfirm) {
            this.onConfirm();
            this.dialogClientService.hide();
        }
    }
    // onConfirm(): Promise<void> {
    //     return new Promise((resolve, reject) => {
            
    //         this.validator.validate().then(v => {
    //             if (v.valid) {
    //                 this.deleteFunc(this.items, this.reason).then(x => {
    //                     resolve();
    //                     this.dialogClientService.hide();
    //                 }).catch(error => {
    //                     reject();
    //                 });
    //             }
    //             else reject();
    //         }).catch(error => {
    //             reject();
    //         });
    //     });
    // }

}